import { render, staticRenderFns } from "./GlbAppearanceEditor.vue?vue&type=template&id=fb559f7e&scoped=true"
import script from "./GlbAppearanceEditor.vue?vue&type=script&lang=js"
export * from "./GlbAppearanceEditor.vue?vue&type=script&lang=js"
import style0 from "./GlbAppearanceEditor.vue?vue&type=style&index=0&id=fb559f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb559f7e",
  null
  
)

export default component.exports